/**
 * Loads search, localization, and cart chrome on first interaction.
 * Do not prefetch these on idle — that regresses TBT.
 */
(function () {
  const groups = window.sbChromeScriptGroups || {};
  const loaded = {};
  const loading = {};

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load ${src}`));
      document.head.appendChild(script);
    });

  const loadSequential = async (urls) => {
    for (const src of urls) {
      if (!src) continue;
      await loadScript(src);
    }
  };

  const ensureStandardEvents = async () => {
    if (window.StandardEvents) return;
    const StandardEvents = await import('https://cdn.shopify.com/storefront/standard-events.js');
    window.StandardEvents = StandardEvents;
  };

  const loadGroup = (name) => {
    if (loaded[name]) return Promise.resolve();
    if (loading[name]) return loading[name];

    const urls = (groups[name] || []).filter(Boolean);
    if (!urls.length) {
      loaded[name] = true;
      return Promise.resolve();
    }

    loading[name] = (async () => {
      if (name === 'cart') await ensureStandardEvents();
      await loadSequential(urls);
      const waitDefined = (tag) =>
        Promise.race([
          customElements.whenDefined(tag),
          new Promise((resolve) => setTimeout(resolve, 4000)),
        ]);
      if (name === 'search') {
        const waits = [];
        if (urls.some((src) => src.includes('details-modal'))) waits.push(waitDefined('details-modal'));
        if (urls.some((src) => src.includes('snoozebaby-predictive-search'))) waits.push(waitDefined('predictive-search'));
        await Promise.all(waits);
      }
      if (name === 'localization' && urls.length) await waitDefined('localization-form');
      if (name === 'cart' && urls.some((src) => src.includes('snoozebaby-cart-drawer'))) {
        await waitDefined('cart-drawer');
      }
      loaded[name] = true;
    })().catch(() => {
      loading[name] = null;
    });

    return loading[name];
  };

  const menuNav = document.querySelector('[data-sb-mega-menu-src]');
  if (menuNav) {
    const menuSrc = menuNav.getAttribute('data-sb-mega-menu-src');
    const loadMegaMenu = () => {
      if (!menuSrc || document.querySelector(`script[src="${menuSrc}"]`)) return;
      const script = document.createElement('script');
      script.src = menuSrc;
      script.defer = true;
      document.head.appendChild(script);
    };
    menuNav.addEventListener('pointerenter', loadMegaMenu, { once: true, passive: true });
    menuNav.addEventListener('focusin', loadMegaMenu, { once: true });
  }

  const closestGroup = (target) => {
    if (!(target instanceof Element)) return null;
    if (target.closest('#cart-icon-bubble, .header__icon--cart, cart-drawer, product-form, .product-form, .sb-cta, .quick-add')) {
      return 'cart';
    }
    if (target.closest('details-modal, .header__search, .header__icon--search')) {
      return 'search';
    }
    if (target.closest('localization-form, .sb-language-picker, .header-localization')) {
      return 'localization';
    }
    return null;
  };

  const onPointer = (event) => {
    const name = closestGroup(event.target);
    if (name) loadGroup(name);
  };

  const onClick = (event) => {
    const name = closestGroup(event.target);
    if (!name || loaded[name]) return;
    event.preventDefault();
    event.stopPropagation();
    const el =
      event.target.closest(
        '#cart-icon-bubble, summary, button, [type="submit"], a.header__icon, .localization-form__select'
      ) || event.target;
    loadGroup(name).then(() => {
      if (typeof el.click === 'function') el.click();
    });
  };

  document.addEventListener('pointerenter', onPointer, true);
  document.addEventListener('pointerdown', onPointer, true);
  document.addEventListener('focusin', onPointer, true);
  document.addEventListener('click', onClick, true);
})();
